import { IGroup } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { GroupWorkItem } from 'src/app/business/user-management/group-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class GroupsCommandHandler extends EntityCommandHandler<IGroup> {
  protected workItem: IWorkItem<IGroup>;

  constructor(groupWorkItem: GroupWorkItem) {
    super();
    this.workItem = groupWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'GroupDto';
  }
}
